module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [(_vm.showLoadingBg) ? _c('div', {
    staticClass: "context"
  }) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/common/loading.gif")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b207b95"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Loading.vue
// module id = 761
// module chunks = 1